import React, { useState, useEffect } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import {
  getBugById,
  updateBugStatus,
  deleteBug,
} from "../../services/bugService";

const BugDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [bug, setBug] = useState(null);
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);
  const goBack = () => {
    navigate("/bugs");
  };
  useEffect(() => {
    async function fetchBug() {
      try {
        const data = await getBugById(id);
        setBug(data);
      } catch (error) {
        console.error("Failed to fetch bug details:", error);
      } finally {
        setLoading(false);
      }
    }
    fetchBug();
  }, [id]);

  /* ===================== ADDED HANDLERS ===================== */

  const handleStatusChange = async (value) => {
    setUpdating(true);
    try {
      console.log(value);
      let res = await updateBugStatus(id, value);
      console.log(res);
      setBug((prev) => ({ ...prev, status: value }));
    } catch {
      alert("Failed to update status");
    } finally {
      setUpdating(false);
    }
  };

  const handlePriorityChange = async (value) => {
    setUpdating(true);
    try {
      await updateBugStatus(id, { priority: value });
      setBug((prev) => ({ ...prev, priority: value }));
    } catch {
      alert("Failed to update priority");
    } finally {
      setUpdating(false);
    }
  };

  const handleDelete = async () => {
    if (!window.confirm("Are you sure you want to delete this bug?")) return;
    try {
      let res = await deleteBug(id);
      console.log(res);
      
      goBack();
    } catch {
      alert("Failed to delete bug");
    }
  };

  /* ========================================================== */

  if (loading)
    return <div className="p-6 text-center text-gray-600">Loading...</div>;

  if (!bug)
    return <div className="p-6 text-center text-gray-500">Bug not found.</div>;

  return (
    <div className="p-0 md:p-6 max-w-5xl mx-auto space-y-6">
      {/* HEADER */}
      <div className="flex justify-between items-center mb-4 flex-wrap gap-2">
        <h1 className="text-2xl font-bold">Bug Detail</h1>

        <div className="flex gap-2">
          <Link
            to={`/bugs/${bug.id}/edit`}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
          >
            Edit
          </Link>

          <button
            onClick={handleDelete}
            className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition"
          >
            Delete
          </button>

          <button
            onClick={() => goBack()}
            className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition"
          >
            ← Back
          </button>
        </div>
      </div>

      {/* MAIN CARD */}
      <div className="bg-white rounded-xl shadow-sm border p-5 space-y-6">
        {/* TITLE + PRIORITY */}
        <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3">
          <div>
            <h2 className="text-xl font-semibold">{bug.title}</h2>
            <p className="text-sm text-gray-500 mt-1">Bug ID: #{bug.id}</p>
          </div>
        </div>

        {/* DESCRIPTION */}
        <div>
          <h3 className="font-semibold text-gray-700 mb-1">Description</h3>
          <p className="text-gray-600 leading-relaxed">
            {bug.description || "No description provided."}
          </p>
        </div>

        {/* META INFO */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm">
          <InfoItem label="Project" value={bug.projectTitle} />

          <InfoItem
            label="Status"
            value={
              <select
                value={bug.status}
                disabled={updating}
                onChange={(e) => handleStatusChange(e.target.value)}
                className="border px-2 py-1 rounded text-xs"
              >
                <option value="open">Open</option>
                <option value="in-progress">In Progress</option>
                <option value="resolved">Resolved</option>
              </select>
            }
          />

          <InfoItem label="Reported On" value={bug.createdAt} />

          <InfoItem
            label="Priority"
            value={
              <select
                value={bug.priority}
                disabled={updating}
                onChange={(e) => handlePriorityChange(e.target.value)}
                className="border px-2 py-1 rounded text-xs"
              >
                <option value="low">Low</option>
                <option value="medium">Medium</option>
                <option value="high">High</option>
              </select>
            }
          />
        </div>
      </div>
    </div>
  );
};

/* ===================== SMALL COMPONENT ===================== */

const InfoItem = ({ label, value }) => (
  <div className="bg-gray-50 rounded-lg p-3">
    <p className="text-xs uppercase tracking-wide text-gray-500 mb-1">
      {label}
    </p>
    <div className="text-gray-800 font-medium">{value}</div>
  </div>
);

export default BugDetail;
